import React, { useState } from "react";
import SetupCard from "src/pages/GetStarted/Onboarding/SetupCard";
import AddPoshmarkExtensionDialog from "src/components/AddPoshmarkExtensionDialog";
import mercariIcon from "src/assets/platforms/Mercari.svg";
import poshmarkIcon from "src/assets/platforms/Poshmark.svg";
import whatnotIcon from "src/assets/platforms/Whatnot.svg";
import vintedIcon from "src/assets/platforms/Vinted.svg";
import depopIcon from "src/assets/platforms/Depop.svg";

import {
  getExtensionId,
  MissingExtensionError,
  OutdatedExtensionError,
} from "src/utils/extension";
import { completeUserSetupQuestionCardPlatform } from "src/apiService/modules/users";
import type { ExtensionPlatformIntegration } from "src/pages/GetStarted/Onboarding/utils";

interface ExtensionPlatformProps {
  platform: ExtensionPlatformIntegration;
  onClick: () => void;
  completed?: boolean;
  isRunning?: boolean;
}

const LogoByPlatform: Record<ExtensionPlatformProps["platform"], string> = {
  Mercari: mercariIcon,
  Poshmark: poshmarkIcon,
  Whatnot: whatnotIcon,
  Vinted: vintedIcon,
  Depop: depopIcon,
};

const ExtensionPlatformCard = ({
  platform,
  onClick,
  completed = false,
  isRunning = false,
}: ExtensionPlatformProps) => {
  const [open, setOpen] = useState(false);
  const [needsUpdate, setNeedsUpdate] = useState(false);
  const logo = LogoByPlatform[platform];

  return (
    <>
      <SetupCard
        title={platform}
        imageSrc={logo}
        description={"Click the button below to connect to " + platform}
        buttonText={"Connect " + platform}
        onButtonClick={async () => {
          try {
            getExtensionId();
          } catch (e) {
            if (e instanceof MissingExtensionError) {
              setNeedsUpdate(false);
              setOpen(true);
              return;
            } else if (e instanceof OutdatedExtensionError) {
              setNeedsUpdate(true);
              setOpen(true);
            }
            return;
          }
          onClick();
        }}
        points={30}
        completed={completed}
        isRunning={isRunning}
        onManualComplete={() =>
          completeUserSetupQuestionCardPlatform(platform, {
            source: "user-dismissed",
          })
        }
        footerNote={
          platform === "Depop"
            ? "The depop integration is still in beta"
            : platform === "Vinted"
            ? "The vinted integration is still in beta"
            : undefined
        }
      />
      <AddPoshmarkExtensionDialog
        open={open}
        platform={platform}
        update={needsUpdate}
        onClose={async () => {
          setOpen(false);
        }}
      />
    </>
  );
};

export default ExtensionPlatformCard;
